import {mapGetters} from "vuex";

import {VueSlideToggle} from 'vue-slide-toggle'

export default {
    name: 'active-item-module',
    props: {
        data: {
            type: Object,
            default: {}
        },
        course: {
            type: Object,
            default: {}
        },
    },
    components: {
        VueSlideToggle
    },
    data() {
        return {
            isShowItemList: false,
            isMobile: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.onResize()
            window.addEventListener('resize', this.onResize, {passive: true});
        })
    },
    computed: {
        ...mapGetters({}),
    },
    methods: {
        onResize() {
            this.isMobile = window.innerWidth < 900;
            this.isShowItemList = window.innerWidth < 900;
        },
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize);
    }
}
